export const getScrollLeftToCenterColumn = ({
  columnIndex,
  columnWidth,
  offsetStart,
  viewportWidth,
}: {
  columnIndex: number
  columnWidth: number
  offsetStart: number
  viewportWidth: number
}) => Math.max(offsetStart + columnIndex * columnWidth + columnWidth / 2 - viewportWidth / 2, 0)
